import EnhanceLoadable from "./EnhanceLoadable";
import Spinner from "theme/components/atoms/Spinner";
import { SpinnerFullPage } from "theme/components/atoms/Spinner";

const Loadable = (isLoaded, isFullPage) =>
  EnhanceLoadable(isLoaded, Spinner, isFullPage, SpinnerFullPage);

export default Loadable;
